import React from 'react';
import { Grid, List, ListItem } from '@mui/material';
import { localize } from 'util/Localizer';
import { museoSansFont300 } from 'util/EnumHelper';

/* eslint-disable max-len */
const startingText = [
    `School districts can enable even safer handoffs at school by giving teachers and school staff access to EverDriven VIP. With this first-of-its-kind app, teachers and other school staff will receive student and driver ETAs for convenient and safe student handoffs.`,
    `To ensure the safety of every student, only District Portal admins may grant app access to teachers and school staff.`
];

const endingText = [`The new user will receive an email from us with instructions on how to get started with EverDriven VIP.`];

const items = [
    `Log in to District Portal.`,
    `Navigate to Users in the navigation bar.`,
    `Click the plus sign to add a new user. To ensure student safety, each school employee must be added individually, even when staff members share a mobile device to use the app.`,
    `Enter the new user’s information including first name, last name, and email address.`,
    `Under Mobile Access, select VIP App.`,
    `Select the school or schools where the new user meets students transported by EverDriven.`,
    `To finish, select Create and Send Invitation.`
];
/* eslint-enable max-len */

function HowToGrantAppAccess() {
    return (
        <Grid container spacing={2}>
            <Grid container columns={{ xs: 6, sm: 6, md: 12 }} sx={{
                fontFamily: museoSansFont300,
                fontSize: 16
            }}>
                <Grid item xs={6}>
                    <List>
                        {startingText.map(text => (
                            <ListItem key={text}>{text}</ListItem>
                        ))}
                    </List>
                    <ol>
                        {items.map((item) => (
                            <li key={item}>{item}</li>
                        ))}
                    </ol>
                    <List>
                        {endingText.map(text => (
                            <ListItem key={text}>{text}</ListItem>
                        ))}
                    </List>
                </Grid>
                <Grid item xs={6} sx={{ mt: '24px' }}>
                    <img
                        src="/img/Students-with-disabilities-in-front-of-school-with-teachers.png"
                        alt={localize('howtograntappaccess.imgAltText')}
                        width="100%"
                    />
                </Grid>
            </Grid>
        </Grid>
    );
}

export default HowToGrantAppAccess;
